import { render, staticRenderFns } from "./TipBioPanel.vue?vue&type=template&id=1acc93ba&"
import script from "./TipBioPanel.vue?vue&type=script&lang=js&"
export * from "./TipBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports